const bannersicb = [
    {
        "size": "",
        "style": "",
        "class": "",
        "children": [
            {
                "type": "topbar",
                "size": "12",
                "style": "",
                "class": "px-4",
                "title": 'Banners',
            },
            {
                "type": "tabs",
                "size": "12",
                "style": "",
                "class": "px-4",
                "children": [
                    {
                        "title": "Banners",
                        "service": "pages",
                        "type": "",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": false,
                            "deleteButton": false, 
                            "activeLimit": 8,
                            "addNewSuccessTitle": 'Topic Added!',
                            "addNewSuccessMessage": 'Topic Added Successfully!',
                            "addNewErrorTitle": 'Topic Creation Failed!',
                            "addNewErrorMessage": 'Please try again!',
                            "deleteSuccessTitle": 'Topic Deleted!',
                            "deleteSuccessMessage": 'Topic Deleted Successfully!',
                            "deleteErrorTitle": 'Topic Deletion Failed!',
                            "deleteErrorMessage": 'Please try again!',
                            "activeSuccessTitle": 'Topic Activated!',
                            "activeSuccessMessage": 'Topic Activated Successfully!',
                            "activeErrorTitle": 'Topic Activation Failed!',
                            "activeErrorMessage": 'Please try again!',
                            "updateSuccessTitle": 'Topic Updated!',
                            "updateSuccessMessage": 'Topic Updated Successfully!',
                            "updateErrorTitle": 'Topic Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                            "addNewModal": {
                                "title": "Add New Page",
                                "variant": "add",
                                "submit_url": "/api/categories/$currentCategoryId/pages",
                                "form": {
                                    "title": {
                                    "type": 'text',
                                    "label": 'Title',
                                    "placeholder": 'Enter Title',
                                    "required": true,
                                    "info": true,
                                    "character_count": 250,
                                    "disabled": false,
                                    "class": '',
                                    "size": "12",
                                    "style": ""
                                    },
                                    // "group": {
                                    //     "type": 'footerGroupSelect',
                                    //     "label": 'Group',
                                    //     "placeholder": 'Select Group',
                                    //     "load_url": '',
                                    //     "required": false,
                                    //     "info": false,
                                    //     "character_count": 0,
                                    //     "disabled": false,
                                    //     "class": '',
                                    //     "size": "12",
                                    //     "style": ""
                                    // },
                                    // "subgroup": {
                                    //     "type": 'subgroupSelect',
                                    //     "label": 'Sub-Group',
                                    //     "placeholder": 'Select Sub-Group',
                                    //     "load_url": '',
                                    //     "required": false,
                                    //     "info": false,
                                    //     "character_count": 0,
                                    //     "disabled": false,
                                    //     "class": '',
                                    //     "size": "6",
                                    //     "style": ""
                                    // },
                                },
                                "additionalProps": {
                                    "practices": {
                                        all: false,
                                        valuePcns: [],
                                        valuePractices: []
                                    },
                                    "web": "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/icb_bnrs/econsult_web.png",
                                    "tablet": "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/icb_bnrs/econsult_tablet.png",
                                    "mobile": "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/icb_bnrs/econsult_mobile.png",
                                    // "color": '#00a5ef',
                                    // "icon": 'https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/building.svg',
                                    // "tool": 'eConsult',
                                    // "link_type":"External Link",
                                    // "link_url":"",
                                    // "subgroup": '',
                                    // "locations": '',
                                    // "qualifications": '',
                                    // "availability": {
                                    //     'locations':  []
                                    // },
                                    // "gender": {
                                    //     'name':  'Male'
                                    // },
                                }
                            }
                        },
                        "children": [
                            {
                                "type": "quickLinksTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                        "label": "Links",
                                        // "type": "list",
                                        "type": "list",
                                        // "variant": "filtered",
                                        "filter": "labels",
                                        "filterOn": "group",
                                        "info": true,
                                        "size": "4",
                                        "style": "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                        "class": "p-0 pr-3 pt-3",
                                        "load_url": "/api/categories/$currentCategoryId/pages",
                                        "draggable": true,
                                        "children": [
                                        ]
                                    },
                                    "form": {
                                        "title": "Tab Two",
                                        "type": "form",
                                        "variant": "patch",
                                        "size": "8",
                                        "class": "pl-4 pt-3",
                                        "submit_url": "/api/pages/$currentPageId",
                                        "form": {
                                            "preview": {
                                                "type": 'bannersPreview',
                                                "label": 'Banner',
                                                "required": false,
                                                "info": false,
                                                "character_count": 0,
                                                "disabled": false,
                                                "class": '',
                                                "size": "12",
                                                "style": "",
                                            },
                                            "practices": {
                                                "type": 'selectObjectMultiLocPlaces',
                                                "label": 'Select',
                                                "placeholder": 'Location List',
                                                // "displayOn": 'locations',
                                                // "displayOnValue": 'true',
                                                "hideLabel": true,
                                                "required": false,
                                                "info": false,
                                                "character_count": 0,
                                                "disabled": false,
                                                "class": '',
                                                "size": "12",
                                                "style": ""                                  
                                            },
                                        },
                                        "children": [
                                        ]
                                    }
                            },
                        ]
                    },
                ]
            }
        ]
    }
]

export { bannersicb };